import { useState } from 'react';
import { ArrowRight, KeyRound } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Checkbox } from '@/components/ui/Checkbox';
import { RecoveryCodesList } from '@/components/common/RecoveryCodesList';
import { SectionCard } from '@/components/common/SectionCard';
import { RECOVERY_CODES_STRINGS as R } from '@/lib/constants/two-factor-strings';

export interface RecoveryCodesSaveCardProps {
  codes: readonly string[];
  /** Starts the session; only reachable once the user confirms they saved the codes. */
  onContinue: () => void;
  /** The continue button's words; the Issue Report journey names its next step. */
  continueLabel?: string;
}

/** Last step of authenticator setup (MYN-241): save the recovery codes, then continue. */
export function RecoveryCodesSaveCard({ codes, onContinue, continueLabel = R.CONTINUE }: RecoveryCodesSaveCardProps) {
  const [saved, setSaved] = useState(false);

  return (
    <SectionCard title={R.HEADING} icon={<KeyRound size={20} />}>
      <RecoveryCodesList codes={codes} />
      <div className="mt-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        <Checkbox
          label={R.ACKNOWLEDGE}
          checked={saved}
          onChange={(event) => setSaved(event.target.checked)}
        />
        <Button
          type="button"
          variant="navy"
          disabled={!saved}
          onClick={onContinue}
          className="inline-flex items-center gap-2 px-8 py-3.5 text-base"
        >
          {continueLabel}
          <ArrowRight size={18} aria-hidden="true" />
        </Button>
      </div>
    </SectionCard>
  );
}
